/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { LocationSignpostRightIcon16Light } from './LocationSignpostRightIcon16Light';
import { LocationSignpostRightIcon16Regular } from './LocationSignpostRightIcon16Regular';
import { LocationSignpostRightIcon16Solid } from './LocationSignpostRightIcon16Solid';
import { LocationSignpostRightIcon20Light } from './LocationSignpostRightIcon20Light';
import { LocationSignpostRightIcon20Regular } from './LocationSignpostRightIcon20Regular';
import { LocationSignpostRightIcon20Solid } from './LocationSignpostRightIcon20Solid';
import { LocationSignpostRightIcon24Regular } from './LocationSignpostRightIcon24Regular';
import { LocationSignpostRightIcon24Solid } from './LocationSignpostRightIcon24Solid';
import { LocationSignpostRightIcon32Regular } from './LocationSignpostRightIcon32Regular';
import { LocationSignpostRightIcon64Regular } from './LocationSignpostRightIcon64Regular';
var sizes = {
    16: {
        light: LocationSignpostRightIcon16Light,
        regular: LocationSignpostRightIcon16Regular,
        solid: LocationSignpostRightIcon16Solid,
    },
    20: {
        light: LocationSignpostRightIcon20Light,
        regular: LocationSignpostRightIcon20Regular,
        solid: LocationSignpostRightIcon20Solid,
    },
    24: {
        regular: LocationSignpostRightIcon24Regular,
        solid: LocationSignpostRightIcon24Solid,
    },
    32: {
        regular: LocationSignpostRightIcon32Regular,
    },
    64: {
        regular: LocationSignpostRightIcon64Regular,
    },
};
export var LocationSignpostRightIcon = forwardRef('LocationSignpostRightIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
